<template>
  <div class="antialiased text-gray-900 flex flex-col min-h-screen bg-gray-200">
    <div class="">
      <AppDropdown>
        <template slot="toggler">
          <slot></slot>
          <!-- {{ hasDefaultSlot }} -->
          <button :class="classes" v-if="!hasSlot()">
            {{ buttonText }}
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="ml-1 h-5 w-5 fill-current text-gray-700"
            >
              <path
                d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
              ></path>
            </svg> -->
          </button>
        </template>
        <AppDropdownContent :autoWidth="autoWidth" :class="contentClasses">
          <slot
            name="content"
            v-if="hasSlot('content')"
            
          />
          <AppDropdownItem
            v-else
            v-for="(menu, index) in list"
            :key="index"
            :value="menu.key"
            @onClick="menu.disabled?null:emit(menu)"
          >
            {{ menu.text }}
          </AppDropdownItem>
          <div v-if="!list.length && !hasSlot('content')" @onClick="() => ({})">
            {{ noItemsFoundMessage }}
          </div>
        </AppDropdownContent>
      </AppDropdown>
    </div>
  </div>
</template>

<script>
import AppDropdown from "./AppDropdown.vue";
import AppDropdownContent from "./AppDropdownContent.vue";
import AppDropdownItem from "./AppDropdownItem.vue";

import("./style.css");

export default {
  name: "DropdownMenu",
  props: {
    buttonText: {
      type: String,
      default: "Click",
    },
    classes: {
      type: String,
      default: "",
    },
    contentClasses: {
      type: String,
      default: "",
    },
    hideItemList: {
      type: Boolean,
      default: false,
    },
    noItemsFoundMessage: {
      type: String,
      default: "No Items found",
    },
    autoWidth: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    autoEmit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emit(unit) {
      
      this.$emit("selected", unit);
    },
    hasSlot: function(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
  computed: {
    // hasDefaultSlot: function() {
    //   return this.$slots.default;
    // },
    // hasContentSlot: function() {
    //   return this.$slots.content;
    // },
  },
  components: {
    AppDropdown,
    AppDropdownContent,
    AppDropdownItem,
  },
};
</script>
<style scoped>
.menu{
  max-height: 500px !important;
  overflow: scroll !important;
}
</style>